














import { Component, Mixins, Vue } from "vue-property-decorator";
import SettingMixin from "@/mixins/settingMixin";
import ContainImage from "@/components/ContainImage.vue";
import ImageButton from "@/components/ImageButton.vue";

@Component({
  components: {
    ContainImage,
    ImageButton,
  },
})
export default class SystemError extends Mixins(Vue, SettingMixin) {
  get systemError(): string {
    return `./images/campaign/${this.config.imageName.errorPopup.systemError}`;
  }
  get goToTopPage(): string {
    return `./images/campaign/${this.config.imageName.errorPopup.goToTopPage}`;
  }
}
